






























import { Vue, Prop, Component } from 'vue-property-decorator';
import LoaderCircular, { EnumColors } from '@/components/LoaderCircular.vue';
import { ITheme } from '@signing-page/entity/types/theme';
import { BrandingHelper } from '@signing-page/helpers/branding.helper';

@Component({
  components: {
    LoaderCircular,
  },
})
export default class ThemedButton extends Vue {
  @Prop({ default: false }) dense: boolean;
  @Prop({ default: false }) mobile: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) icon: boolean;
  @Prop({ default: false }) isLoading: boolean;
  @Prop({ default: false }) rounded: boolean;
  @Prop({ default: false }) centered: boolean;
  @Prop({ default: false }) secondary: boolean;
  @Prop({ default: false }) disableHover: boolean;
  @Prop({ default: false }) customHover: boolean;
  @Prop({ default: false }) isHovered: boolean;
  @Prop() theme!: ITheme;

  handleClick(event) {
    this.$emit('click', event);
  }

  get loaderColor(): string {
    if (this.theme && this.theme.textColor) {
      return this.theme.textColor;
    }
    return EnumColors.primary;
  }

  get buttonStyle() {
    if (this.theme && this.theme.accentColor && this.theme.textColor) {
      return {
        '--button-background-color': BrandingHelper.getBackgroundColor(
          this.theme.accentColor,
          this.disabled,
          this.secondary
        ),
        '--button-background-color--hover': BrandingHelper.getBackgroundColorHover(
          this.theme.accentColor,
          this.disabled,
          this.secondary
        ),
        '--button-text-color': BrandingHelper.getTextColor(
          this.theme.accentColor,
          this.disabled,
          this.secondary
        ),
        '--button-border-color': BrandingHelper.getBorderColor(
          this.theme.accentColor,
          this.disabled,
          this.secondary
        ),
        '--button-border-color--hover': BrandingHelper.getBorderColorHover(
          this.theme.accentColor,
          this.disabled,
          this.secondary
        ),
      };
    }
    return {};
  }

  get activeCustomHover(): boolean {
    return this.customHover && this.isHovered;
  }
}
